import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { CancelIcon } from "../../SvgComponents/CancelIcon/CancelIcon";
import { RefreshIcon } from "../../SvgComponents/RefreshIcon/RefreshIcon";
import { WarningIcon } from "../../SvgComponents/WarningIcon/WarningIcon";
import "./InvalidFormatModal.css";

export const InvalidFormatModal = ({ open, onCancel, onLoadImage, title, description }) => {
  const { t } = useTranslation();
  const modalTitle = title ?? t('document_id.invalid_format_modal_title');
  const modalDescription = description ?? t('document_id.invalid_format_modal_description');

  return (
    <Modal
      footer={null}
      open={open}
      closable={true}
      onCancel={onCancel}
      className="invalid-format-modal"
      width={840}

    >
      <div className="invalid-format-content">
        <WarningIcon />
        <h3 className="invalid-format-title">{modalTitle}</h3>
        <p className="invalid-format-description">{modalDescription}</p>
        <div className="modal-buttons-container">
          <button onClick={onCancel}>
            <span>{t('general.cancel')}</span>
            <CancelIcon />
          </button>
          <button onClick={onLoadImage}>
            <span>{t('document_id.load_image')}</span>
            <RefreshIcon />
          </button>
        </div>
      </div>
    </Modal>
  );
};
